import userSlice from "./user";
import bansSlice from "./bans";
import routerSlice from "./router";
import cookieSlice from "./cookies";

export default {
  user: userSlice,
  bans: bansSlice,
  cookies: cookieSlice,
  router: routerSlice,
};
